import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import PublicLicensingBoardsLanding from './PublicLicensingBoardsLanding';
import '../../styles/Unclaimed-CME-Dashboard.css';

const PublicCMERequirements: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'CME Requirements by State';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh' }}>
      <div className="Right-Div-individual-Dashboard">
        <div style={{ padding: '20px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ fontSize: '40px', fontWeight: 600, color: '#000', lineHeight: '120%' }}>
            CME Requirements by State
          </div>
          <TextField
            placeholder="Search by state name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            size="small"
            inputProps={{
              className: 'no-border-input'
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#999' }} />
                </InputAdornment>
              ),
              endAdornment: searchQuery ? (
                <InputAdornment position="end">
                  <ClearIcon
                    onClick={() => setSearchQuery('')}
                    style={{ cursor: 'pointer', fontSize: '18px', color: '#999' }}
                  />
                </InputAdornment>
              ) : null
            }}
            sx={{
              minWidth: '250px',
              maxWidth: '350px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '50px',
                backgroundColor: '#FFFFFF',
                '& fieldset': { borderColor: '#DDDDDD' },
                '&:hover fieldset': { borderColor: '#1976D2' },
                '&.Mui-focused fieldset': { borderColor: '#1976D2', borderWidth: '1px' }
              },
              '& input': { cursor: 'text !important' }
            }}
          />
        </div>
        <PublicLicensingBoardsLanding searchQuery={searchQuery} />
      </div>
    </div>
  );
};

export default PublicCMERequirements;
